import React, {
  useState,
  useCallback,
  useMemo,
  memo,
  useEffect,
  useRef,
} from "react";
import PropTypes from "prop-types";
import AOS from "aos/dist/aos";
import _ from "lodash";
import { withStyles, withWidth, isWidthUp } from "@material-ui/core";
import { useNavigation } from "hooks";
import Footer from "components/Footer";
import "aos/dist/aos.css";
import { Navigation } from "utils/constant";
import NavBar from "./navigation/NavBar";
import CookieRulesDialog from "./cookies/CookieRulesDialog";
import CookieConsent from "./cookies/CookieConsent";
import Routing from "./Routing";

AOS.init({ once: true });

const styles = (theme) => {
  // console.log(theme);
  return {
    wrapper: {
      overflowX: "hidden",
    },
  };
};

// 移动端Bscroll带有footer
const hideFooter = [
  "notifies",
  "back-purchased",
  "back-order",
  "back-invoice",
  "payment",
];

function Main(props) {
  const { classes, width } = props;
  const selectedTab = useNavigation();
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [isCookieRulesDialogOpen, setIsCookieRulesDialogOpen] = useState(false);
  const [footerHeight, setFooterHeight] = useState(0);
  const footerRef = useRef(null);

  const handleMobileDrawerOpen = useCallback(() => {
    setIsMobileDrawerOpen(true);
  }, [setIsMobileDrawerOpen]);

  const handleMobileDrawerClose = useCallback(() => {
    setIsMobileDrawerOpen(false);
  }, [setIsMobileDrawerOpen]);

  const handleCookieRulesDialogOpen = useCallback(() => {
    setIsCookieRulesDialogOpen(true);
  }, [setIsCookieRulesDialogOpen]);

  const handleCookieRulesDialogClose = useCallback(() => {
    setIsCookieRulesDialogOpen(false);
  }, [setIsCookieRulesDialogOpen]);

  const footerView = useMemo(() => {
    if (!isWidthUp("md", width) && _.includes(hideFooter, selectedTab)) {
      return null;
    }
    if (selectedTab === Navigation.contact.value) {
      return null;
    }
    return <Footer selectedTab={selectedTab} />;
  }, [selectedTab, width]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFooterHeight(footerRef.current.clientHeight);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={classes.wrapper}>
      {!isCookieRulesDialogOpen && (
        <CookieConsent
          handleCookieRulesDialogOpen={handleCookieRulesDialogOpen}
        />
      )}
      <CookieRulesDialog
        open={isCookieRulesDialogOpen}
        onClose={handleCookieRulesDialogClose}
      />
      <NavBar
        selectedTab={selectedTab}
        mobileDrawerOpen={isMobileDrawerOpen}
        handleMobileDrawerOpen={handleMobileDrawerOpen}
        handleMobileDrawerClose={handleMobileDrawerClose}
      />
      <div style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
        <Routing />
      </div>
      <footer ref={footerRef}>{footerView}</footer>
    </div>
  );
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withWidth()(withStyles(styles, { withTheme: true })(memo(Main)));
